import clsx from 'clsx';
import React from 'react';

const SpeakerIcon = (props: { size: string; className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 640"
    height={props.size}
    width={props.size}
    className={clsx('tw-relative -tw-top-[0.09em]', props.className)}
  >
    <path
      fill="currentColor"
      d="M375.9 230.1L176 430.1L176 394C176 338.8 197.9 285.9 236.9 246.9L340.7 143.2C360.7 123.2 387.8 112 416 112C444.2 112 471.3 123.2 491.3 143.2L496.8 148.7C516.8 168.7 528 195.8 528 224C528 240.8 524 257.3 516.6 272L402 272L409.9 264.1C419.3 254.7 419.3 239.5 409.9 230.2C400.5 220.9 385.3 220.8 376 230.2zM353.9 320L476.1 320L428.1 368L305.9 368L353.9 320zM378.8 416C341.6 446.9 294.6 464 245.9 464L209.9 464L257.9 416L378.8 416zM128 394L128 478L71 535C61.6 544.4 61.6 559.6 71 568.9C80.4 578.2 95.6 578.3 104.9 568.9L161.9 511.9L245.9 511.9C313.8 511.9 378.9 484.9 426.9 436.9L530.7 333.3C559.7 304.3 576 265 576 224C576 183 559.7 143.7 530.7 114.7L525.2 109.2C496.3 80.3 457 64 416 64C375 64 335.7 80.3 306.7 109.3L203 213C155 261 128 326.1 128 394z"
    />
  </svg>
);

export default SpeakerIcon;
